import { SaleRepository } from "@/repositories/sale-repository"
import { type ISale } from "@/interfaces/api/sale.interface"
import { Sale } from "@/models/sale.model"
import { useSaleStore } from "@/store/sale.store"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { SaleItem } from "@/models/sale-item.model"
import { type Moment } from "moment"

export default class SaleController extends GenericModelController<Sale, ISale, SaleRepository> {
  constructor() {
    const { pushToRelatedObjects, removeFromRelatedObjects } = useSaleStore()

    const storeFunctionsConfig = {
      onCreate: pushToRelatedObjects,
      onDelete: removeFromRelatedObjects
    }

    super(Sale, storeFunctionsConfig, new SaleRepository())
  }

  public async applyPricesRetroactively(saleItem: SaleItem, retroactiveDate: Moment) {
    return this.apiFunctions.getRepository().applyPricesRetroactively(saleItem, retroactiveDate)
  }
}
